import { SEO } from "@/components/SEO";
import { PageHero } from "@/components/PageHero";
import { Services } from "@/components/Services";
import { Process } from "@/components/Process";
import { CTASection } from "@/components/CTASection";
import { SERVICES } from "@/lib/data";

export default function ServicesPage() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    itemListElement: SERVICES.map((s, i) => ({
      "@type": "Service",
      position: i + 1,
      name: s.title,
      description: s.desc,
      provider: { "@type": "Organization", name: "LD Media" },
    })),
  };

  return (
    <>
      <SEO
        title="Services"
        path="/services"
        description="LD Media tilbyder Meta Ads, Google Ads, TikTok Ads, organic marketing, social media management, hjemmesider, SEO optimization, video redigering og UGC content."
        jsonLd={jsonLd}
      />
      <PageHero
        eyebrow="Services"
        title="Alt hvad du skal bruge for at"
        accent="vækste digitalt."
        subtitle="Vi bygger skræddersyede digitale kunderejser der engagerer din målgruppe og konverterer dem til betalende kunder. Fra ads og content til hjemmesider og SEO."
      />
      <Services showCta={false} hideHeading />
      <Process />
      <CTASection title="Klar til at komme i gang?" />
    </>
  );
}
